import React from 'react';
import '../../scss/components/TextInput.scss';

interface FakeInputProps {
    value:string|number|null|undefined,
    className?:string,
    wrapperClassName?:string,
    required?:boolean,
    label?:string,
    labelPosition?:string,
};

const FakeInput = ({
    value,
    className,
    wrapperClassName,
    required,
    label,
    labelPosition = 'before',
}:FakeInputProps) => {
    return (
        <div className={`form-group text-input${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            { label && label.length > 0 && labelPosition === 'before' ? (
                <span className='label'>{label} {required ? '*' : ''}</span>
            ) : <></>}
            <span className={(className ? 'input ' + className : 'input')}>
                { value }
            </span>
            { label && label.length > 0 && labelPosition === 'after' ? (
                <span className='label'>{label} {required ? '*' : ''}</span>
            ) : <></>}
        </div>
    )
}

export default FakeInput;